if(document.querySelector('.events-agenda')) {
    document.querySelectorAll('.date-tab').forEach(tab => {
        tab.addEventListener('click', function() {
            document.querySelectorAll('.date-tab.active').forEach(el => el.classList.remove('active'));
            this.classList.add('active');

            const scheduleIndex = this.getAttribute('schedule-index');

            document.querySelector('.date-select').value = scheduleIndex;

            document.querySelectorAll('.schedule-day-container').forEach(el => el.classList.remove('active'));
            document.querySelector(`.schedule-day-container[schedule-index="${scheduleIndex}"]`).classList.add('active');
        });
    });

    document.querySelector('.date-select').addEventListener('change', function() {
        const scheduleIndex = this.value;

        document.querySelectorAll('.date-tab.active').forEach(el => el.classList.remove('active'));
        document.querySelector(`.date-tab[schedule-index="${scheduleIndex}"]`).classList.add('active');

        document.querySelectorAll('.schedule-day-container').forEach(el => el.classList.remove('active'));
        document.querySelector(`.schedule-day-container[schedule-index="${scheduleIndex}"]`).classList.add('active');
    });

    document.querySelectorAll('.session-open-button').forEach(button => {
        button.addEventListener('click', function() {
            const sessionID = this.getAttribute('session_id');
            document.querySelector(`.ind-session-container[session_id="${sessionID}"] .desc-container`).classList.toggle('active');
            this.classList.toggle('open');
        });
    });
}